import * as React from 'react';
import { connect } from 'react-redux';
import find from 'lodash/find';
import get from 'lodash/get';
import matchesProperty from 'lodash/matchesProperty';
import { IApplicationState } from '../../types/redux';
import { trackPopularAds } from '../../utils/helpers/metrics_helper';
import { ITopGroup, ITopThree } from '../../types/top_three';
import { setSaleGroupSelected } from '../../reducers/modules/top_three';
import { PopularList } from '../../components/popular_list/popular_list';

interface IProps {
  id: string;
  title: string;
  groups: ITopGroup[];
  topThree: ITopThree;
  setSaleGroupSelected(index: string): void;
}

class SalesBlock extends React.Component<IProps> {
  public componentDidMount() {
    this.props.setSaleGroupSelected(this.props.groups[0].id);
  }

  public getOffers() {
    return get(find(this.props.groups, matchesProperty('id', this.props.topThree.groupSaleSelected)), 'offers', []);
  }

  public getProductData(group: string = this.props.topThree.groupSaleSelected) {
    return get(find(this.props.groups, matchesProperty('id', group)), 'trackingProductData', []);
  }

  private onTabClick(eventLabel: string) {
    trackPopularAds(eventLabel, { impressions: this.getProductData(eventLabel) });
  }

  private onItemClick(order: number) {
    const products = this.getProductData();
    trackPopularAds(this.props.topThree.groupSaleSelected, {
      click: {
        actionField: { list: 'main_page' },
        products: products.length > order ? [products[order]] : [],
      },
    });
  }

  public render() {
    return (
      <PopularList
        id={this.props.id}
        title={this.props.title}
        groups={this.props.groups}
        selectItem={(index: string) => this.props.setSaleGroupSelected(index)}
        isItemSelected={(index: string) => this.props.topThree.groupSaleSelected === index}
        onTabClick={(eventLabel: string) => this.onTabClick(eventLabel)}
        onItemClick={(order: number) => this.onItemClick(order)}
        getOffers={() => this.getOffers()}
      />
    );
  }
}

type StateProps = Pick<IProps, 'topThree'>;
type DispatchProps = Pick<IProps, 'setSaleGroupSelected'>;
type OwnProps = Omit<IProps, keyof (StateProps & DispatchProps)>;

const SalesBlockWrapper = connect<StateProps, DispatchProps, OwnProps, IApplicationState>(
  state => ({
    topThree: state.topThree,
  }),
  dispatch => ({
    setSaleGroupSelected: (index: string) => {
      dispatch(setSaleGroupSelected(index));
    },
  }),
)(SalesBlock);

export { SalesBlockWrapper as SalesBlock, SalesBlock as SalesBlockClass };
